import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 原因模板列表
const reasonList = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.config_setting_reason_list + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

// 添加原因模板
const reasonSave = obj => new Promise((resolve, reject) => {
    const {
        reasonTemplateForm,
        token
    } = obj
    request({
        url: apis.config_setting_reason_save + '?token=' + token,
        data: reasonTemplateForm
    }).then(res => {
        resolve(res);
    })
})

// 删除原因模板
const reasonDel = obj => new Promise((resolve, reject) => {
    const {
        reasonTemplateForm,
        token
    } = obj
    request({
        url: apis.config_setting_reason_del + '?token=' + token ,
        data: reasonTemplateForm
    }).then(res => {
        resolve(res);
    })
})

// 言论标签列表
const opinionTagList = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.config_setting_opinion_list + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

// 添加言论标签
const opinionTagSave = obj => new Promise((resolve, reject) => {
    const {
        opinionTagForm,
        token
    } = obj
    request({
        url: apis.config_setting_opinion_save + '?token=' + token,
        data: opinionTagForm
    }).then(res => {
        resolve(res);
    })
})

// 删除言论标签
const opinionTagDel = obj => new Promise((resolve, reject) => {
    const {
        opinionTagForm,
        token
    } = obj
    request({
        url: apis.config_setting_opinion_del + '?token=' + token ,
        data: opinionTagForm
    }).then(res => {
        resolve(res);
    })
})

// 渠道列表
const channelList = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.config_setting_channel_list + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

// 增加渠道
const channelSave = obj => new Promise((resolve, reject) => {
    const {
        channelForm,
        token
    } = obj
    request({
        url: apis.config_setting_channel_save + '?token=' + token,
        data: channelForm
    }).then(res => {
        resolve(res);
    })
})

// 删除渠道
const channelDel = obj => new Promise((resolve, reject) => {
    const {
        channelForm,
        token
    } = obj
    request({
        url: apis.config_setting_channel_del + '?token=' + token ,
        data: channelForm
    }).then(res => {
        resolve(res);
    })
})

// 媒体值列表
const mediaList = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.config_setting_media_list + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

// 增加媒体值
const mediaSave = obj => new Promise((resolve, reject) => {
    const {
        mediaForm,
        token
    } = obj
    request({
        url: apis.config_setting_media_save + '?token=' + token,
        data: mediaForm
    }).then(res => {
        resolve(res);
    })
})

// 删除媒体值
const mediaDel = obj => new Promise((resolve, reject) => {
    const {
        mediaForm,
        token
    } = obj
    request({
        url: apis.config_setting_media_del + '?token=' + token ,
        data: mediaForm
    }).then(res => {
        resolve(res);
    })
})

export default {
    reasonList,
    reasonSave,
    reasonDel,
    opinionTagList,
    opinionTagSave,
    opinionTagDel,
    channelList,
    channelSave,
    channelDel,
    mediaList,
    mediaSave,
    mediaDel
}



// WEBPACK FOOTER //
// ./src/service/config_setting_api.js